// extracted by mini-css-extract-plugin
export default {"success":"#188038","edit":"#f80","error":"#bf360c","primary":"#00a8f1","primarybackground":"#e8f0fe","primaryactive":"#06458e","font":"#202124","italic":"#444"};